export enum SettingsTab {

    Funds = "funds",
    Profile = "profile",
}
